import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsString } from '@pit/core';
import { IDtoResourceFault } from '../interfaces/dto.resource.fault.interface';
import { DtoResourceFault } from './dto.resource.fault';
import { ExternalOrderTransferState, IDtoResourceCheckItem } from '../interfaces/dto.resource.check.item.interface';

// @dynamic
@JsonObject('DtoResourceCheckItem')
export class DtoResourceCheckItem extends ModelEntity implements IDtoResourceCheckItem {

    constructor(initValues: Partial<IDtoResourceCheckItem> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('checkResult', Number, true)
    public checkResult?: number = 0;

    @JsonProperty('faultArea', String, true)
    public faultArea?: string = null;

    @JsonProperty('faultCategory', String, true)
    public faultCategory?: string = null;

    @JsonProperty('faultCode', String, true)
    public faultCode?: string = null;

    @JsonProperty('faultDescription', String, true)
    public faultDescription?: string = null;

    @JsonProperty('faultPenalty', Number, true)
    public faultPenalty?: number = 0;

    @JsonProperty('isFault', Boolean, true)
    public isFault?: boolean = false;

    @JsonProperty('notes', String, true)
    public notes?: string = null;

    @JsonProperty('externalOrderId', String, true)
    public externalOrderId?: string = null;

    @JsonProperty('externalOrderTransferStateExport', Number, true)
    public externalOrderTransferStateExport?: ExternalOrderTransferState.NotTransferred;

    @JsonProperty('externalOrderTransferTimestampExport', UtilsJsonConverterDate, true)
    public externalOrderTransferTimestampExport?: Date = null;

    @JsonProperty('externalOrderTransferStateImport', Number, true)
    public externalOrderTransferStateImport?: ExternalOrderTransferState = ExternalOrderTransferState.NotTransferred;

    @JsonProperty('externalOrderTransferTimestampImport', UtilsJsonConverterDate, true)
    public externalOrderTransferTimestampImport?: Date = null;

    public getFullDescription(): string {
        let result: string = this.faultDescription;
        if (UtilsString.stringIsNullOrEmpty(this.faultArea) === false) {
            result = this.faultArea + ' ' + result;
        }

        return result;
    }

}
